export default "__VITE_ASSET__CggnM8in__"